export const firebaseConfig = {
  apiKey: "AIzaSyBfndJCqIr8TG5rHU4R7r_0icvl2Rlv-xM",
  authDomain: "iotconnect-hauber-graf.firebaseapp.com",
  projectId: "iotconnect-hauber-graf",
  storageBucket: "iotconnect-hauber-graf.appspot.com",
  messagingSenderId: "639123452881",
  appId: "1:639123452881:web:9cee83f573442ca7e966f0"
};
